import { render } from "./ReporteRecepcionEquipo.vue?vue&type=template&id=73dfd793&scoped=true"
import script from "./ReporteRecepcionEquipo.vue?vue&type=script&lang=js"
export * from "./ReporteRecepcionEquipo.vue?vue&type=script&lang=js"

import "./ReporteRecepcionEquipo.vue?vue&type=style&index=0&id=73dfd793&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73dfd793"]])

export default __exports__